<script lang="ts">
  import type { CtaBlock } from 'query-strapi-v4';
  import CtaWithImageTop from './WithImage/ImageTop.svelte';
  import CtaWithImageRight from './WithImage/ImageRight.svelte';

  export let title: string = '';
  export let description: string = '';
  export let image: CtaBlock['featured_image'];

  export let onClick: () => void = () => {};
  export let link: CtaBlock['link'] = undefined;

  export let layout: 'image-top' | 'image-right' = 'image-top';

  $: featuredImage = {
    src: image?.data?.attributes?.url,
    width: image?.data?.attributes?.width,
    height: image?.data?.attributes?.height
  };
</script>

<div
  class="-mx-4 my-8 bg-zinc-50 sm:mx-0 sm:rounded-2xl dark:bg-gray-1000 dark:border-zinc-700 border hover:dark:border-gray-1000 hover:border-zinc-50 hover:shadow-lg hover:dark:shadow-zinc-700 no-prose not-prose relative overflow-hidden"
>
  {#if layout === 'image-right'}
    <CtaWithImageRight
      src={featuredImage.src}
      alt={title}
      height={featuredImage.height}
      width={featuredImage.width}
    />
  {:else}
    <CtaWithImageTop
      src={featuredImage.src}
      alt={title}
      height={featuredImage.height}
      width={featuredImage.width}
      {title}
      {description}
      {onClick}
      {link}
    />
  {/if}
</div>
